import { createApp, DirectiveBinding } from 'vue'
import App from './App.vue'
import router from './router'
import CustomInput from '@/components/common/CustomInput.vue'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import 'dayjs/locale/ru'

import './assets/main.css'
import './assets/custom.css'
import './assets/transitions.css'
import NobrFix from './components/common/NobrFix.vue'

createApp(App)
  .use(router)
  .component('CustomInput', CustomInput)
  .component('VueDatePicker', VueDatePicker)
  .component('Nobr', NobrFix)
  .directive('loading', (el: HTMLElement, binding: DirectiveBinding<boolean|undefined>) => {
    if (binding.value || binding.value === undefined) {
      el.classList.add('loading')
    } else {
      el.classList.remove('loading')
    }
  })
  .mount('#app')
